(function () {
  'use strict';

  if (window.NYTarpColorTiles) {
    window.NYTarpColorTiles.init(document);
    return;
  }

  var familyRequests = {};

  function enhanceSaleUnit(section) {
    var label = section.querySelector('[data-sale-unit]');
    var data = section.querySelector('[data-sale-units]');
    var master = section.querySelector('form select[name="id"]');
    if (!label || !data || !master || label.dataset.saleUnitReady === 'true') return;
    var units;
    try {
      units = JSON.parse(data.textContent);
    } catch (error) { return; }
    if (!units || typeof units !== 'object' || Array.isArray(units)) return;
    label.dataset.saleUnitReady = 'true';
    var unavailable = false;

    function update(variantId) {
      var unit = units[String(variantId)];
      label.textContent = typeof unit === 'string' ? unit : '';
      label.hidden = !label.textContent;
    }

    function afterNativeChange() {
      queueMicrotask(function () { update(unavailable ? '' : master.value); });
    }
    master.form.querySelectorAll('select.single-option-selector').forEach(function (select) {
      select.addEventListener('change', afterNativeChange);
    });
    master.addEventListener('change', function () {
      unavailable = false;
      afterNativeChange();
    });
    if (window.jQuery) {
      window.jQuery(section).on('variantChange.nytarpSaleUnit', function (event) {
        unavailable = !event.variant;
        update(event.variant ? event.variant.id : '');
      });
    }
    update(master.value);
  }

  function imageFor(container, variant, handle) {
    if (!container || !variant) return;
    var generated = window.NYTarpGeneratedImages && window.NYTarpGeneratedImages.get(handle);
    var source = generated ? generated.url : variant.image;
    var image = container.querySelector('img');
    if (!source) {
      if (image) image.remove();
      return;
    }
    if (!image) {
      image = document.createElement('img');
      image.alt = '';
      image.loading = 'lazy';
      container.appendChild(image);
    }
    if (image.getAttribute('src') !== source) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = source;
    }
    image.width = generated ? generated.width : variant.image_width || 320;
    image.height = generated ? generated.height : variant.image_height || 240;
    image.alt = generated ? generated.alt : variant.alt || '';
    if (generated) image.style.height = 'auto';
  }

  function enhanceNative(root, section) {
    var data = root.querySelector('[data-color-tiles-data]');
    var fieldset = root.querySelector('[data-color-tiles-native]');
    var optionIndex = Number(root.dataset.colorOptionIndex);
    if (!data || !fieldset || root.dataset.colorOptionIndex === '') return 0;
    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (error) {
      return 0;
    }
    var form = root.closest('form');
    var selects = Array.prototype.slice.call((form || section).querySelectorAll('select.single-option-selector'));
    var colorSelect = selects.find(function (select) {
      return select.dataset.index === 'option' + (optionIndex + 1);
    });
    var buttons = Array.prototype.slice.call(root.querySelectorAll('button[data-color-value]'));
    var wrapper = colorSelect && colorSelect.closest('.selector-wrapper');
    if (!Array.isArray(variants) || !variants.length || !colorSelect || !wrapper || !buttons.length) return 0;
    if (!variants.every(function (variant) { return Array.isArray(variant.options); })) return 0;
    var productData = document.getElementById('ProductJson-' + section.dataset.sectionId);
    var nativeProduct = {};
    try {
      nativeProduct = productData ? JSON.parse(productData.textContent) : {};
    } catch (error) {}
    var nativeVariants = Array.isArray(nativeProduct.variants) ? nativeProduct.variants : [];
    var thumbnails = Array.prototype.slice.call(section.querySelectorAll('.product-single__thumbnail[data-product-image-id]'));
    var mainImage = section.querySelector('.product-featured-img');
    var originalColor = colorSelect.value;
    var originalImageAlt = mainImage ? mainImage.getAttribute('alt') || '' : '';

    function findVariant(color, matchOtherOptions) {
      return variants.find(function (variant) {
        if (variant.options[optionIndex] !== color) return false;
        return !matchOtherOptions || selects.every(function (select) {
          var index = Number(select.dataset.index.replace('option', '')) - 1;
          return index === optionIndex || variant.options[index] === select.value;
        });
      });
    }

    function nativeVariantFor(variant) {
      return variant && nativeVariants.find(function (candidate) { return String(candidate.id) === String(variant.id); });
    }

    function update() {
      var selectedLabel = root.querySelector('[data-color-tiles-selected]');
      if (selectedLabel) selectedLabel.textContent = colorSelect.value;
      buttons.forEach(function (button) {
        var value = button.dataset.colorValue;
        var variant = findVariant(value, true);
        var selected = value === colorSelect.value;
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
        button.disabled = !variant;
        button.querySelector('[data-color-tile-price]').textContent = variant ? variant.price : '';
        button.querySelector('[data-color-tile-status]').textContent = !variant ? root.dataset.unavailable : variant.available ? '' : root.dataset.soldOut;
        imageFor(button.querySelector('[data-color-tile-image]'), variant || findVariant(value, false), root.dataset.currentHandle);
      });
      if (!buttons.some(function (button) { return !button.disabled && button.tabIndex === 0; })) {
        var first = buttons.find(function (button) { return !button.disabled; });
        if (first) first.tabIndex = 0;
      }
      var current = findVariant(colorSelect.value, true);
      if (buttons.length > 1 && thumbnails.length) {
        var colorImageIds = nativeVariants.filter(function (variant) {
          return Array.isArray(variant.options) && variant.options[optionIndex] === colorSelect.value && variant.featured_image && variant.featured_image.id != null;
        }).map(function (variant) { return String(variant.featured_image.id); });
        var visibleImageIds = [];
        thumbnails.forEach(function (thumbnail) {
          var id = thumbnail.dataset.productImageId;
          thumbnail.hidden = colorImageIds.indexOf(id) === -1;
          if (!thumbnail.hidden && visibleImageIds.indexOf(id) === -1) visibleImageIds.push(id);
        });
        var thumbnailStrip = thumbnails[0].closest('.nytarp-product__thumbs');
        if (thumbnailStrip) thumbnailStrip.hidden = visibleImageIds.length <= 1;
      }
      if (mainImage) {
        var nativeVariant = nativeVariantFor(current);
        var variantAlt = nativeVariant && nativeVariant.featured_image && nativeVariant.featured_image.alt;
        var fallbackAlt = colorSelect.value === originalColor && originalImageAlt ? originalImageAlt : [colorSelect.value, nativeProduct.title].filter(Boolean).join(' — ');
        mainImage.alt = current && current.image ? variantAlt || fallbackAlt : '';
        section.querySelectorAll('img.zoomImg[alt]').forEach(function (image) {
          if (image.getAttribute('alt')) image.alt = mainImage.alt;
        });
      }
      if (buttons.length > 1) {
        var photo = section.querySelector('.nytarp-product__featured, .product-single__photo');
        if (photo) {
          var panel = photo.querySelector('[data-color-photo-placeholder]');
          if (!current || !current.image) {
            photo.setAttribute('data-color-photo-missing', '');
            if (!panel) {
              panel = document.createElement('div');
              panel.className = 'nytarp-color-photo-placeholder';
              panel.setAttribute('data-color-photo-placeholder', '');
              panel.setAttribute('role', 'status');
              photo.appendChild(panel);
            }
            panel.textContent = (root.dataset.photoUnavailableTemplate || '').replace('[color]', colorSelect.value);
          } else {
            photo.removeAttribute('data-color-photo-missing');
            if (panel) panel.remove();
          }
        }
      }
    }

    function choose(button) {
      if (button.disabled) return;
      if (colorSelect.value !== button.dataset.colorValue) {
        colorSelect.value = button.dataset.colorValue;
        colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var selectedVariant = nativeVariantFor(findVariant(colorSelect.value, true));
        if (buttons.length > 1 && selectedVariant && selectedVariant.featured_image && window.jQuery) {
          window.jQuery(section).trigger({ type: 'variantImageChange', variant: selectedVariant });
        }
      }
      update();
      if (window.NYTarpGeneratedImages) window.NYTarpGeneratedImages.applyProduct(section, root.dataset.currentHandle);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () { choose(button); });
      button.addEventListener('keydown', function (event) {
        var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (keys.indexOf(event.key) === -1) return;
        var enabled = buttons.filter(function (candidate) { return !candidate.disabled; });
        if (!enabled.length) return;
        event.preventDefault();
        var position = enabled.indexOf(button);
        var backwards = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
        if (getComputedStyle(root).direction === 'rtl' && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) backwards = !backwards;
        var next = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1 : (position + (backwards ? -1 : 1) + enabled.length) % enabled.length;
        enabled[next].focus();
        choose(enabled[next]);
      });
    });
    selects.forEach(function (select) { select.addEventListener('change', function () {
      update();
      if (window.NYTarpGeneratedImages) window.NYTarpGeneratedImages.applyProduct(section, root.dataset.currentHandle);
    }); });
    update();
    if (window.NYTarpGeneratedImages) window.NYTarpGeneratedImages.applyProduct(section, root.dataset.currentHandle);
    wrapper.setAttribute('data-color-tiles-enhanced', '');
    root.hidden = false;
    return buttons.length;
  }

  function enhanceVariantGallery(root, section) {
    if (root.dataset.colorOptionIndex !== '') return;
    var data = document.getElementById('ProductJson-' + section.dataset.sectionId);
    var product;
    try {
      product = data ? JSON.parse(data.textContent) : null;
    } catch (error) { return; }
    if (!product || !Array.isArray(product.variants)) return;
    var imageIds = [];
    product.variants.forEach(function (variant) {
      var image = variant.featured_image;
      if (image && image.id != null && imageIds.indexOf(String(image.id)) === -1) imageIds.push(String(image.id));
    });
    if (imageIds.length < 2) return;
    var form = root.closest('form');
    var master = form && form.querySelector('select[name="id"]');
    if (!master) return;
    var thumbnails = Array.prototype.slice.call(section.querySelectorAll('.product-single__thumbnail[data-product-image-id]'));
    var thumbnailStrip = thumbnails.length && thumbnails[0].closest('.nytarp-product__thumbs');
    var mainImage = section.querySelector('.product-featured-img');

    function update(restoreImage) {
      if (!root.isConnected) return;
      var variant = product.variants.find(function (candidate) { return String(candidate.id) === master.value; });
      var image = variant && variant.featured_image;
      thumbnails.forEach(function (thumbnail) {
        thumbnail.hidden = !image || String(image.id) !== thumbnail.dataset.productImageId;
      });
      if (thumbnailStrip) thumbnailStrip.hidden = true;
      if (restoreImage && image && window.jQuery) {
        window.jQuery(section).trigger({ type: 'variantImageChange', variant: variant });
      }
      var alt = image ? image.alt || [product.title, variant.title].filter(Boolean).join(' — ') : '';
      if (mainImage) mainImage.alt = alt;
      section.querySelectorAll('img.zoomImg[alt]').forEach(function (zoom) {
        if (zoom.getAttribute('alt')) zoom.alt = alt;
      });
      var photo = section.querySelector('.nytarp-product__featured, .product-single__photo');
      if (!photo) return;
      var panel = photo.querySelector('[data-color-photo-placeholder]');
      if (image) {
        photo.removeAttribute('data-color-photo-missing');
        if (panel) panel.remove();
      } else {
        photo.setAttribute('data-color-photo-missing', '');
        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'nytarp-color-photo-placeholder';
          panel.setAttribute('data-color-photo-placeholder', '');
          panel.setAttribute('role', 'status');
          photo.appendChild(panel);
        }
        panel.textContent = (root.dataset.photoUnavailableTemplate || '').replace('[color]', variant ? variant.title : product.title);
      }
    }

    function afterNativeChange() {
      queueMicrotask(function () { update(true); });
    }
    form.querySelectorAll('select.single-option-selector').forEach(function (select) {
      select.addEventListener('change', afterNativeChange);
    });
    master.addEventListener('change', afterNativeChange);
    update(false);
  }

  function enhanceThumbnailAlt(section) {
    section.querySelectorAll('.product-single__thumbnail').forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        setTimeout(function () {
          if (!thumbnail.isConnected || thumbnail.hidden || !thumbnail.getClientRects().length || getComputedStyle(thumbnail).visibility === 'hidden') return;
          var image = thumbnail.querySelector('img');
          var mainImage = section.querySelector('.product-featured-img');
          if (!image || !mainImage || mainImage.getAttribute('src') !== thumbnail.getAttribute('href')) return;
          mainImage.alt = image.getAttribute('alt') || '';
          section.querySelectorAll('img.zoomImg[alt]').forEach(function (zoom) {
            if (zoom.getAttribute('alt')) zoom.alt = mainImage.alt;
          });
        }, 0);
      });
    });
  }

  function enhanceFamily(root, section) {
    var url = root.dataset.colorProductsUrl;
    var family = root.querySelector('[data-color-tiles-family]');
    var grid = root.querySelector('[data-color-tiles-family-grid]');
    var enquiries = root.querySelector('[data-color-tiles-enquiries]');
    var enquiryGrid = root.querySelector('[data-color-tiles-enquiry-grid]');
    var enquiryLabel = root.querySelector('[data-color-enquiry-label]');
    var afterBuy = section.querySelector('[data-color-tiles-after-buy]');
    if (!url || !family || !grid) return;
    if (afterBuy) {
      afterBuy.appendChild(family);
      if (enquiries) afterBuy.appendChild(enquiries);
    }
    if (!familyRequests[url]) {
      familyRequests[url] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Color navigation unavailable');
        return response.json();
      });
    }
    familyRequests[url].then(function (groups) {
      if (!root.isConnected) return;
      var entries = groups[root.dataset.currentHandle];
      if (!Array.isArray(entries)) return;
      var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' });

      function validPrice(price) {
        return /^\d+(\.\d{1,2})?$/.test(String(price));
      }

      function validProductUrl(entry) {
        if (typeof entry.handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(entry.handle)) return false;
        var target = '/products/' + entry.handle;
        if (entry.variantId != null) {
          if (typeof entry.variantId !== 'string' || !/^\d+$/.test(entry.variantId)) return false;
          target += '?variant=' + entry.variantId;
        }
        return entry.url === target;
      }

      function tile(entry, isEnquiry) {
        var link = document.createElement('a');
        link.className = 'nytarp-color-tiles__tile';
        link.href = entry.url;
        if (isEnquiry) link.setAttribute('data-color-enquiry', '');
        else if (entry.handle === root.dataset.currentHandle) link.setAttribute('aria-current', 'page');
        var image = document.createElement('span');
        image.className = 'nytarp-color-tiles__image';
        imageFor(image, { image: entry.image }, entry.handle);
        var label = document.createElement('span');
        label.className = 'nytarp-color-tiles__label';
        label.textContent = entry.label;
        link.appendChild(image);
        link.appendChild(label);
        var generated = window.NYTarpGeneratedImages && window.NYTarpGeneratedImages.get(entry.handle);
        if (generated && generated.caption) {
          var caption = document.createElement('span');
          caption.className = 'nytarp-color-tiles__status';
          caption.textContent = generated.caption;
          link.appendChild(caption);
        }
        if (validPrice(entry.price)) {
          var price = document.createElement('span');
          price.className = 'nytarp-color-tiles__price';
          price.textContent = formatter.format(Number(entry.price));
          link.appendChild(price);
        }
        if (isEnquiry) {
          var action = document.createElement('span');
          action.className = 'nytarp-color-tiles__status';
          action.textContent = enquiryLabel ? enquiryLabel.textContent : '';
          link.appendChild(action);
        }
        return link;
      }

      var products = entries.filter(function (entry) {
        return entry && (!entry.kind || entry.kind === 'product') && typeof entry.label === 'string' && validProductUrl(entry) && validPrice(entry.price);
      });
      var navigationProducts = products.filter(function (entry) { return entry.handle !== root.dataset.currentHandle; });
      if (navigationProducts.length) {
        navigationProducts.forEach(function (entry) { grid.appendChild(tile(entry, false)); });
        family.setAttribute('data-color-tiles-siblings', '');
        var heading = family.querySelector('[data-color-tiles-family-heading]');
        if (heading && family.dataset.colorSiblingsHeading) {
          heading.textContent = family.dataset.colorSiblingsHeading;
        }
        family.hidden = false;
        (afterBuy || root).hidden = false;
      }
      if (!enquiries || !enquiryGrid) return;
      var availableEnquiries = entries.filter(function (entry) {
        if (!entry || entry.kind !== 'enquiry' || typeof entry.label !== 'string' || typeof entry.url !== 'string') return false;
        if (entry.price != null && !validPrice(entry.price)) return false;
        try {
          var target = new URL(entry.url);
          return target.protocol === 'mailto:' && decodeURIComponent(target.pathname).toLowerCase() === 'sales@nytarp.com' && Array.from(target.searchParams.keys()).every(function (key) { return key === 'subject' || key === 'body'; });
        } catch (error) {
          return false;
        }
      });
      if (availableEnquiries.length) {
        availableEnquiries.forEach(function (entry) { enquiryGrid.appendChild(tile(entry, true)); });
        enquiries.hidden = false;
        (afterBuy || root).hidden = false;
      }
    }).catch(function () {});
  }

  function init(scope) {
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-nytarp-color-tiles]'));
    if (scope.matches && scope.matches('[data-nytarp-color-tiles]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.dataset.colorTilesReady === 'true') return;
      var section = root.closest('[data-section-type="product"]');
      if (!section) return;
      root.dataset.colorTilesReady = 'true';
      enhanceSaleUnit(section);
      enhanceNative(root, section);
      enhanceVariantGallery(root, section);
      enhanceThumbnailAlt(section);
      enhanceFamily(root, section);
    });
  }

  window.NYTarpColorTiles = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
